import {
  anonymousClient,
  emailOTPClient,
  inferAdditionalFields,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  baseURL: import.meta.env.VITE_APP_URL,
  basePath: "/auth",
  plugins: [
    anonymousClient(),
    emailOTPClient(),
    inferAdditionalFields({
      user: {
        isOnboarded: { type: "boolean" },
        isAnonymous: { type: "boolean" },
        // Lifecycle state from the user doc; absent/null means active. Declared
        // here so it reaches the browser at all — without this,
        // `session.user.status` is not part of the inferred session type.
        status: { type: "string", required: false },
      },
      session: {
        impersonatedBy: { type: "string", required: false },
        impersonationReason: { type: "string", required: false },
      },
    }),
  ],
});
